import visaLogo from "./visa-logo.png";
import mastercardLogo from "./Mastercard-Logo.wine.png";
import azulLogo from "./AZULLogo.png";

/** Payment logos using local assets in components folder (no external links). Colors kept. */

export function AzulLogo({ className = "h-5 w-auto inline-block align-middle" }: { className?: string }) {
  return <img src={azulLogo} alt="Azul" className={className} />;
}

export function VisaLogo({ className = "h-8 w-auto opacity-90" }: { className?: string }) {
  return <img src={visaLogo} alt="Visa" className={className} />;
}

export function MastercardLogo({ className = "h-8 w-auto opacity-90" }: { className?: string }) {
  return <img src={mastercardLogo} alt="Mastercard" className={className} />;
}
